export const enum PriorityCodeEnum {
  VERYLOW = 'VERYLOW',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  VERYHIGH = 'VERYHIGH',
}

export type PriorityDTOV1 = {
  code: PriorityCodeEnum
  displayOrder: number
  active: boolean
  default: boolean
}
